<div class="nav-container">
  <nav>
    <h2 class="nav-title">Inova - Cartórios</h2>
  </nav>
</div>
